<template>
  <div>
    <span class="title mr-10">选择所属学习班:</span>
    <el-select v-model="value" 
      placeholder="请选择所属学习班" 
      @change="onStudyclassIdChange" 
      class="classs_select" 
      filterable>
      <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id" class="classs_select_option"></el-option>
    </el-select>
  </div>
</template>

<script>
import { options as getOptions } from "@/api/module/studyclass/studyclass";

export default {
  name: "selectStudyclass",
  data() {
    return {
      options : [],
      value : ""
    };
  },
  methods:{
      init() {
        // 包裹参数
        let _this = this;
        getOptions({
          test: 1
        })
          .then(response => {
            this.options = response;
          })
          .catch(error => {
            console.log(error);
          })
          .finally(() => {});
      },
      onStudyclassIdChange(val) {
        let options = this.options;

        for(let i = 0; i < options.length; i++){
          if(options[i].id == val){
            this.$emit("onDataChanged", options[i]);
          }
        }


      },
      // extend
      initData(e) {
        this.value = e;
      },

      clear(){
        this.value = ""
      }
  },
  created(){
    this.init();
  }
}
</script>





<style scoped>
.title {
  font-size: 13px;
  color: #303133;
  display: inline-block;
  width: 110px;
  padding-left: 10px;
  box-sizing: border-box;
  margin-right: 10px;
}

.classs_select{
  max-width: 600px;
}
.classs_select_option{
  max-width: 600px;
}

</style>